/**
 * API configuration
 */

// @ts-ignore - Vite env types
const API_URL = import.meta.env.VITE_API_URL || 'https://trazavolt-api-dev.aforero-spain.workers.dev';

export const apiConfig = {
  baseURL: `${API_URL}/api/v1`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export function getAuthToken(): string | null {
  return localStorage.getItem('auth_token');
}

export function setAuthToken(token: string): void {
  localStorage.setItem('auth_token', token);
}

export function removeAuthToken(): void {
  localStorage.removeItem('auth_token');
}

